import axios from 'axios'
import store from '../store/store'
import {router} from '@/router';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import eventBus from "@/eventBus";
import {getAffinityId} from '@/utils/affinity';

const instance = axios.create({
    baseURL: process.env.VUE_APP_BACKEND_ADDRESS,
});

instance.interceptors.request.use(config => {
    if (store.getters.user.access_token === null || store.getters.user.access_token === 'undefined') {
        if (router.currentRoute.name !== 'login') {
          router.push({name: 'login'});
        }

        return Promise.reject();
    }

    config.headers['Authorization'] = 'Bearer ' + store.getters.user.access_token;
    config.headers['Content-Type'] = 'application/json';

    // Afinidade de sessão do track-tiles-service: injeta ?aff=<id> para que o
    // HAProxy encaminhe toda a sessão para a mesma réplica (ver utils/affinity.js).
    if (typeof config.url === 'string' && config.url.includes('/track-tiles-service/')) {
        config.params = {...(config.params || {}), aff: getAffinityId()};
    }

    return config;
});

const refreshAuthLogic = async failedRequest => {
  try {
    await store.dispatch('refreshTokenAction');

    failedRequest.response.config.headers['Authorization'] = `Bearer ${store.getters.user.access_token}`;

    return Promise.resolve();
  } catch (error) {
    const status = error?.response?.status ?? error?.status;

    if (status === 503 || status === 408) {
      eventBus.$emit('show-toast', {
        type: 'error',
        message: 'Serviço temporariamente indisponível. Tente novamente.'
      });

      return Promise.reject(error);
    }

    if (router.currentRoute.name !== 'login') {
      await router.push({ name: 'login' });
    }
    
    return Promise.reject(error);
  }
};

createAuthRefreshInterceptor(instance, refreshAuthLogic, {
    pauseInstanceWhileRefreshing: true
});

export default instance
